<app-dropdown-menu-animated
  class="density--1"
  [menuContainer]="{
    view: currentView,
    buttonClass: 'new-button',
    contentList: true,
    disableContainer: null,
    disableProp: null
  }"
>
  <mat-list class="content-list-view-selector common-search-menu">
    @for (view of views; track view.name) {
      <button
        type="button"
        mat-menu-item
        (click)="select(view.name)"
        [class.active]="resultViewName === view.name"
      >
        <mat-icon>
          {{ view.icon }}
        </mat-icon>

        <span>
          {{ view.description | translate }}
        </span>
      </button>
    }
  </mat-list>
</app-dropdown-menu-animated>
